import { KNOWLEDGE_BUILDER_ACTIONS } from 'app/store/actions/media/knowledge.actions'
import baseRequestReducer from 'app/store/reducers/base-request.reducer'
import { KnowledgeBuilderInitialState } from 'app/types/theater-reducers.types'

const initialState: KnowledgeBuilderInitialState = {
  data: [],
  loading: true,
  error: false,
}

const KnowledgeBuilder = baseRequestReducer(
  initialState,
  KNOWLEDGE_BUILDER_ACTIONS
)

export default KnowledgeBuilder
